import styled from 'styled-components';

import logo from '../../../images/Croisette_logo_Pink.png';

const Footer = ({ product }) => {
  return (
    <PageFooter product={product}>
      {product === 'croisette-contents' ? (
        <img src={logo} alt='Croisette' />
      ) : (
        <img
          src='https://d2l0gvltru79ov.cloudfront.net/partners/lin/lin.png'
          alt='lin'
        />
      )}
    </PageFooter>
  );
};

export default Footer;

const PageFooter = styled.footer`
  //   width: 100%;
  display: flex;
  justify-content: flex-end;

  img {
    width: ${(props) =>
      props.product === 'croisette-contents' ? '8rem' : '3rem'};
    height: auto;
  }
`;
